export default __webpack_public_path__ + "410c4fa579e795c3d1906fcdddb9dd3d.png";